import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.map.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { getSymbolCurrency, formatPrice } from "@/js/currency/currencies.js";
import { orderTypes, listWineTypes, purchaseOrder } from "@/js/lists.ts";
import WineSupplierPriceModal from "@/components/supplier-prices/WineSupplierPriceModal.vue";
export default {
  name: "SourcingSupplierTable",
  props: {
    datatableLoading: {
      type: Boolean,
      default: false
    },
    itemsProps: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    panelsOpened: {
      type: [Number, Array],
      default: function _default() {
        return [];
      }
    }
  },
  components: {
    WineSupplierPriceModal: WineSupplierPriceModal
  },
  created: function created() {
    this.orders = this.itemsProps;
    this.generateSuppliers();
  },
  data: function data() {
    return {
      orders: [],
      suppliers: [],
      splitGroupCounter: 0,
      highlightedSplitGroupId: null,
      currentSplitScrollIndex: 0,
      splitGroupCounts: new Map(),
      openedPanels: {},
      headers: [{
        align: "center",
        text: "Supplier",
        value: "supplier",
        width: "20%"
      }, {
        align: "center",
        text: "Items",
        value: "items",
        width: "50%"
      }],
      isWineSupplierPriceModalShown: false,
      currentWineId: null,
      orderTypes: orderTypes,
      formatPrice: formatPrice,
      getSymbolCurrency: getSymbolCurrency,
      purchaseOrder: purchaseOrder
    };
  },
  methods: {
    getBestSupplierPrice: function getBestSupplierPrice(wine) {
      var supplierPrices = (wine === null || wine === void 0 ? void 0 : wine.wineSupplierPrices) || [];
      if (supplierPrices.length === 0) return null;
      return supplierPrices.reduce(function (best, current) {
        if (!best || current.price < best.price) {
          return current;
        }
        return best;
      }, null);
    },
    generateSuppliers: function generateSuppliers() {
      var _this = this;
      var supplierMap = new Map();
      var noSupplierPriceKey = "NO_SUPPLIER_PRICE";
      this.splitGroupCounter = 0;
      this.splitGroupCounts = new Map();
      this.orders.forEach(function (order) {
        order.items.forEach(function (item) {
          var associatedPOs = item.associatedPurchaseOrders || [];
          var totalPOQuantity = associatedPOs.reduce(function (sum, po) {
            return sum + po.quantity;
          }, 0);
          if (associatedPOs.length === 0) {
            var bestSupplierPrice = _this.getBestSupplierPrice(item.wine);
            if (bestSupplierPrice) {
              _this.addItemToSupplier(supplierMap, item, order, null, bestSupplierPrice.supplier.id, bestSupplierPrice.supplier.name, false, bestSupplierPrice);
            } else {
              _this.addItemToSupplier(supplierMap, item, order, null, noSupplierPriceKey);
            }
          } else if (associatedPOs.length === 1 && totalPOQuantity >= item.quantity) {
            var _po$supplier, _po$supplier2, _item$wine;
            var po = associatedPOs[0];
            var supplierId = ((_po$supplier = po.supplier) === null || _po$supplier === void 0 ? void 0 : _po$supplier.id) || item.id_supplier;
            var supplierName = ((_po$supplier2 = po.supplier) === null || _po$supplier2 === void 0 ? void 0 : _po$supplier2.name) || ((_item$wine = item.wine) === null || _item$wine === void 0 || (_item$wine = _item$wine.producer) === null || _item$wine === void 0 ? void 0 : _item$wine.name);
            _this.addItemToSupplier(supplierMap, item, order, associatedPOs, supplierId, supplierName);
          } else {
            var _totalPOQuantity = associatedPOs.reduce(function (sum, po) {
              return sum + po.quantity;
            }, 0);
            var remainingQty = item.quantity - _totalPOQuantity;
            _this.splitGroupCounter++;
            var currentSplitGroupId = _this.splitGroupCounter;
            var totalSplitCount = associatedPOs.length;
            if (remainingQty > 0) {
              totalSplitCount++;
            }
            _this.splitGroupCounts.set(currentSplitGroupId, totalSplitCount);
            associatedPOs.forEach(function (po) {
              var _po$supplier3, _po$supplier4, _item$wine2;
              var supplierId = ((_po$supplier3 = po.supplier) === null || _po$supplier3 === void 0 ? void 0 : _po$supplier3.id) || item.id_supplier;
              var supplierName = ((_po$supplier4 = po.supplier) === null || _po$supplier4 === void 0 ? void 0 : _po$supplier4.name) || ((_item$wine2 = item.wine) === null || _item$wine2 === void 0 || (_item$wine2 = _item$wine2.producer) === null || _item$wine2 === void 0 ? void 0 : _item$wine2.name);
              _this.addItemToSupplier(supplierMap, _objectSpread(_objectSpread({}, item), {}, {
                quantity: po.quantity
              }), order, [po], supplierId, supplierName, true, null, currentSplitGroupId);
            });
            if (remainingQty > 0) {
              var _bestSupplierPrice = _this.getBestSupplierPrice(item.wine);
              if (_bestSupplierPrice) {
                _this.addItemToSupplier(supplierMap, _objectSpread(_objectSpread({}, item), {}, {
                  quantity: remainingQty
                }), order, null, _bestSupplierPrice.supplier.id, _bestSupplierPrice.supplier.name, true, _bestSupplierPrice, currentSplitGroupId);
              } else {
                _this.addItemToSupplier(supplierMap, _objectSpread(_objectSpread({}, item), {}, {
                  quantity: remainingQty
                }), order, null, noSupplierPriceKey, null, true, null, currentSplitGroupId);
              }
            }
          }
        });
      });
      var statusOrder = {
        danger: 0,
        warning: 1,
        success: 2
      };
      this.suppliers = Array.from(supplierMap.values()).map(function (supplier) {
        supplier.items.sort(function (a, b) {
          var statusA = _this.getGlobalItemStatus(a);
          var statusB = _this.getGlobalItemStatus(b);
          var orderA = statusOrder[statusA] !== undefined ? statusOrder[statusA] : 99;
          var orderB = statusOrder[statusB] !== undefined ? statusOrder[statusB] : 99;
          return orderA - orderB;
        });
        return supplier;
      }).sort(function (a, b) {
        if (a.isNoSupplierPrice) return -1;
        if (b.isNoSupplierPrice) return 1;
        var statusA = _this.getSupplierStatus(a);
        var statusB = _this.getSupplierStatus(b);
        var orderA = statusOrder[statusA] !== undefined ? statusOrder[statusA] : 99;
        var orderB = statusOrder[statusB] !== undefined ? statusOrder[statusB] : 99;
        return orderA - orderB;
      });
    },
    addItemToSupplier: function addItemToSupplier(supplierMap, item, order, associatedPOs, supplierId) {
      var supplierName = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
      var isSplit = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : false;
      var bestSupplierPrice = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : null;
      var splitGroupId = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : null;
      var isNoSupplierPrice = supplierId === "NO_SUPPLIER_PRICE";
      var finalSupplierId = isNoSupplierPrice ? "NO_SUPPLIER_PRICE" : supplierId || item.id_supplier;
      var finalSupplierName = isNoSupplierPrice ? "/!\\ UNDEFINED SUPPLIER /!\\" : supplierName || "Unknown Supplier";
      if (!supplierMap.has(finalSupplierId)) {
        supplierMap.set(finalSupplierId, {
          id: finalSupplierId,
          name: finalSupplierName,
          isNoSupplierPrice: isNoSupplierPrice,
          items: []
        });
      }
      var supplierEntry = supplierMap.get(finalSupplierId);
      supplierEntry.items.push(_objectSpread(_objectSpread({}, item), {}, {
        reference_order: order.reference_order,
        orderType: order.type,
        associatedPOs: associatedPOs,
        isSplit: isSplit,
        splitIndex: isSplit ? supplierEntry.items.length : undefined,
        splitGroupId: splitGroupId,
        bestSupplierPrice: bestSupplierPrice
      }));
    },
    getPoItemStatus: function getPoItemStatus(poItem, globalItemQuantity) {
      if (poItem.receiptStatus === purchaseOrder.receiptStatus.RECEIVED && poItem.quantity >= globalItemQuantity) return "fas fa-check success";
      if (poItem.receiptStatus === purchaseOrder.receiptStatus.RECEIVED && poItem.quantity < globalItemQuantity) return "fas fa-check warning";
      if (poItem.status === purchaseOrder.status.DRAFT) return "fas fa-hourglass-half danger";
      return "fas fa-hourglass-half warning";
    },
    getGlobalItemStatus: function getGlobalItemStatus(supplierItem) {
      var associatedPOs = supplierItem.associatedPOs || [];
      if (associatedPOs.length === 0) return "danger";
      var totalPOQuantity = associatedPOs.reduce(function (sum, po) {
        return sum + po.quantity;
      }, 0);
      if (associatedPOs.every(function (po) {
        return po.receiptStatus === purchaseOrder.receiptStatus.RECEIVED && po.quantity >= supplierItem.quantity;
      })) return "success";
      if (associatedPOs.some(function (po) {
        return po.receiptStatus === purchaseOrder.receiptStatus.RECEIVED && po.quantity < supplierItem.quantity;
      })) return "warning";
      if (associatedPOs.some(function (po) {
        return po.status === purchaseOrder.status.DRAFT;
      })) return "danger";
      if (totalPOQuantity < supplierItem.quantity) return "warning";
      return "warning";
    },
    getSupplierStatus: function getSupplierStatus(supplier) {
      if (supplier.isNoSupplierPrice) return "danger";
      var hasAllItemsWithPOs = supplier.items.every(function (item) {
        return item.associatedPOs && item.associatedPOs.length > 0;
      });
      if (!hasAllItemsWithPOs) return "danger";
      var hasAnyProblem = supplier.items.some(function (item) {
        if (!item.associatedPOs || item.associatedPOs.length === 0) return true;
        var totalPOQuantity = item.associatedPOs.reduce(function (sum, po) {
          return sum + po.quantity;
        }, 0);
        if (totalPOQuantity < item.quantity) return true;
        return item.associatedPOs.some(function (po) {
          return po.status === purchaseOrder.status.DRAFT;
        });
      });
      if (hasAnyProblem) return "danger";
      var allItemsReceived = supplier.items.every(function (item) {
        if (!item.associatedPOs || item.associatedPOs.length === 0) return false;
        return item.associatedPOs.every(function (po) {
          return po.receiptStatus === purchaseOrder.receiptStatus.RECEIVED;
        });
      });
      return allItemsReceived ? "success" : "warning";
    },
    openSupplierPrices: function openSupplierPrices(wineId) {
      var _this2 = this;
      this.currentWineId = wineId;
      this.isWineSupplierPriceModalShown = true;
      this.$nextTick(function () {
        _this2.$refs.wineSupplierPriceModalRef.open();
      });
    },
    closeSupplierPrices: function closeSupplierPrices() {
      this.isWineSupplierPriceModalShown = false;
    },
    getSplitGroupItems: function getSplitGroupItems(groupId, currentItem) {
      var splitItems = [];
      this.suppliers.forEach(function (supplier) {
        supplier.items.forEach(function (item) {
          if (item.splitGroupId === groupId) {
            if (currentItem && item.id_item === currentItem.id_item && item.splitIndex === currentItem.splitIndex) {
              return;
            }
            var supplierName = supplier.name;
            var poReference = null;
            if (item.associatedPOs && item.associatedPOs.length > 0) {
              var poRef = item.associatedPOs[0].number;
              if (poRef) {
                poReference = "".concat(poRef);
              }
            }
            splitItems.push({
              quantity: item.quantity,
              supplierName: supplierName !== "/!\\ UNDEFINED SUPPLIER /!\\" ? supplierName : null,
              poReference: poReference,
              supplierId: supplier.id,
              itemId: item.id_item,
              splitIndex: item.splitIndex,
              splitGroupId: item.splitGroupId,
              uniqueRef: "split-item-".concat(item.id_item, "-").concat(item.splitIndex)
            });
          }
        });
      });
      return splitItems;
    },
    scrollToSplitItem: function scrollToSplitItem(splitItem) {
      var _this3 = this;
      this.highlightedSplitGroupId = splitItem.splitGroupId;
      this.$set(this.openedPanels, splitItem.supplierId, 0);
      this.$nextTick(function () {
        setTimeout(function () {
          var ref = _this3.$refs[splitItem.uniqueRef];
          if (ref) {
            var element = Array.isArray(ref) ? ref[0] : ref;
            element.scrollIntoView({
              behavior: "smooth",
              block: "center"
            });
          }
        }, 300);
      });
    },
    toggleHighlightSplitGroup: function toggleHighlightSplitGroup(groupId, currentItem) {
      var _this4 = this;
      this.highlightedSplitGroupId = groupId;
      var suppliersWithGroup = [];
      this.suppliers.forEach(function (supplier) {
        var hasGroupItem = supplier.items.some(function (item) {
          return item.splitGroupId === groupId;
        });
        if (hasGroupItem) {
          suppliersWithGroup.push(supplier.id);
        }
      });
      suppliersWithGroup.forEach(function (supplierId) {
        _this4.$set(_this4.openedPanels, supplierId, 0);
      });
    },
    goToOrder: function goToOrder(value) {
      return {
        name: "adminOrderSummary",
        params: {
          id: value
        }
      };
    },
    goToPurchaseOrder: function goToPurchaseOrder(po) {
      return {
        name: "adminEditPurchaseOrder",
        params: {
          id: po.id
        }
      };
    },
    goToProductDetails: function goToProductDetails(wine) {
      var detailsRoute = wine.type == listWineTypes.find(function (x) {
        return x.name === "Spirit";
      }).id ? "adminSpiritsDetails" : "adminWineDetails";
      return {
        name: detailsRoute,
        params: {
          id: wine.id_wine
        }
      };
    }
  }
};